export default __webpack_public_path__ + "static/media/cakeC.bad36d33.png";